export const exportOpenTransactionsToPdf = async (data, reportName, translations) => {
  try {
    // Create print window
    const printWindow = window.open('', '_blank');
    
    if (!printWindow) {
      throw new Error('Please allow popups for this site');
    }

    // Build HTML content
    const html = `
      <!DOCTYPE html>
      <html lang="ar" dir="rtl">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${reportName}</title>
        <style>
          @media print {
            @page {
              size: A4;
              margin: 15mm;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .no-print {
              display: none !important;
            }
            .page-break {
              page-break-after: always;
            }
          }
          
          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            direction: rtl;
            text-align: right;
            padding: 20px;
            background: white;
          }
          
          .header {
            text-align: center;
            margin-bottom: 30px;
            padding: 20px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 10px;
          }
          
          .header h1 {
            margin: 0;
            font-size: 28px;
          }
          
          .info-section {
            margin-bottom: 25px;
            padding: 15px;
            background: #f8f9fa;
            border-right: 4px solid #667eea;
            border-radius: 5px;
          }
          
          .info-row {
            margin: 8px 0;
            font-size: 14px;
          }
          
          .info-label {
            font-weight: bold;
            color: #495057;
          }
          
          .summary-section {
            margin: 25px 0;
            padding: 20px;
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
            color: white;
            border-radius: 10px;
          }
          
          .summary-section h2 {
            margin: 0 0 15px 0;
            font-size: 20px;
          }
          
          .summary-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }
          
          .summary-item {
            padding: 10px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 5px;
          }
          
          .section-title {
            margin: 30px 0 15px 0;
            padding: 12px;
            background: #667eea;
            color: white;
            border-radius: 5px;
            font-size: 18px;
            font-weight: bold;
            text-align: center;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 25px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          thead {
            background: #495057;
            color: white;
          }
          
          th {
            padding: 12px;
            text-align: center;
            font-weight: bold;
            border: 1px solid #dee2e6;
          }
          
          td {
            padding: 10px;
            text-align: center;
            border: 1px solid #dee2e6;
          }
          
          tbody tr:nth-child(even) {
            background: #f8f9fa;
          }
          
          tbody tr:hover {
            background: #e9ecef;
          }
          
          .footer-note {
            margin-top: 30px;
            padding: 15px;
            background: #fff3cd;
            border: 2px solid #ffc107;
            border-radius: 5px;
            text-align: center;
            font-weight: bold;
            color: #856404;
          }
          
          .print-button {
            position: fixed;
            top: 20px;
            left: 20px;
            padding: 12px 24px;
            background: #667eea;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 16px;
            font-weight: bold;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            z-index: 1000;
          }
          
          .print-button:hover {
            background: #5568d3;
          }
        </style>
      </head>
      <body>
        <button class="print-button no-print" onclick="window.print()">طباعة / حفظ كـ PDF</button>
        
        <div class="header">
          <h1>${translations.reportTitle}</h1>
        </div>
        
        <div class="info-section">
          <div class="info-row">
            <span class="info-label">${translations.userName}:</span> ${data.userName}
          </div>
          <div class="info-row">
            <span class="info-label">${translations.barcode}:</span> ${data.barcode}
          </div>
          <div class="info-row">
            <span class="info-label">${translations.patronGroup}:</span> ${data.patronGroup}
          </div>
          <div class="info-row">
            <span class="info-label">${translations.reportDate}:</span> ${new Date().toLocaleDateString('ar-SA')}
          </div>
        </div>
        
        <div class="summary-section">
          <h2>${translations.summary}</h2>
          <div class="summary-grid">
            <div class="summary-item">
              <strong>${translations.totalOpenLoans}:</strong> ${data.openLoansCount}
            </div>
            <div class="summary-item">
              <strong>${translations.totalOpenRequests}:</strong> ${data.openRequestsCount}
            </div>
            <div class="summary-item">
              <strong>${translations.totalOutstandingFees}:</strong> ${data.outstandingFeesCount}
            </div>
            <div class="summary-item">
              <strong>${translations.totalFeeAmount}:</strong> ${data.totalFeeAmount} ${translations.currency}
            </div>
          </div>
        </div>
        
        ${data.openLoans && data.openLoans.length > 0 ? `
          <div class="section-title">${translations.openLoans} (${data.openLoans.length})</div>
          <table>
            <thead>
              <tr>
                <th>${translations.itemTitle}</th>
                <th>${translations.itemBarcode}</th>
                <th>${translations.loanDate}</th>
                <th>${translations.dueDate}</th>
                <th>${translations.overdueDays}</th>
                <th>${translations.status}</th>
              </tr>
            </thead>
            <tbody>
              ${data.openLoans.map(loan => `
                <tr>
                  <td>${loan.itemTitle}</td>
                  <td>${loan.itemBarcode}</td>
                  <td>${loan.loanDate}</td>
                  <td>${loan.dueDate}</td>
                  <td>${loan.overdueDays || 0}</td>
                  <td>${loan.status}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        ` : ''}
        
        ${data.openRequests && data.openRequests.length > 0 ? `
          <div class="section-title">${translations.openRequests} (${data.openRequests.length})</div>
          <table>
            <thead>
              <tr>
                <th>${translations.itemTitle}</th>
                <th>${translations.requestType}</th>
                <th>${translations.requestDate}</th>
                <th>${translations.requestStatus}</th>
                <th>${translations.servicePoint}</th>
              </tr>
            </thead>
            <tbody>
              ${data.openRequests.map(request => `
                <tr>
                  <td>${request.itemTitle}</td>
                  <td>${request.requestType}</td>
                  <td>${request.requestDate}</td>
                  <td>${request.status}</td>
                  <td>${request.servicePoint}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        ` : ''}
        
        ${data.outstandingFees && data.outstandingFees.length > 0 ? `
          <div class="section-title">${translations.outstandingFees} (${data.outstandingFees.length})</div>
          <table>
            <thead>
              <tr>
                <th>${translations.feeType}</th>
                <th>${translations.amount}</th>
                <th>${translations.createdDate}</th>
                <th>${translations.feeStatus}</th>
                <th>${translations.relatedItem}</th>
              </tr>
            </thead>
            <tbody>
              ${data.outstandingFees.map(fee => `
                <tr>
                  <td>${fee.feeType}</td>
                  <td><strong>${fee.amount} ${translations.currency}</strong></td>
                  <td>${fee.createdDate}</td>
                  <td>${fee.status}</td>
                  <td>${fee.relatedItem || '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        ` : ''}
        
        <div class="footer-note">
          ${translations.footerNote}
        </div>
        
        <script>
          // Auto print after page loads
          window.onload = function() {
            setTimeout(function() {
              // Uncomment the line below if you want auto-print
              // window.print();
            }, 500);
          };
        </script>
      </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();

    return { success: true };
  } catch (error) {
    console.error('Error exporting to PDF:', error);
    return { success: false, error };
  }
};
